export default __webpack_public_path__ + "static/media/banner_portrait.5686b3ae.jpg";